import React from 'react'

const Header = () => {
    return (
        <header>
            <h1>New albums & singles</h1>
        </header>
    )
}


export default Header